import { RelocationOrderTransportMethod } from "@/api-schema-enums";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

export const RELOCATION_ORDER_TRANSPORT_METHOD_FILTER_OPTIONS: Record<
  RelocationOrderTransportMethod,
  { id: RelocationOrderTransportMethod; name: string }
> = {
  [RelocationOrderTransportMethod.TransportCompany]: {
    id: RelocationOrderTransportMethod.TransportCompany,
    name: "fit:TransportMethodTransportCompany",
  },
  [RelocationOrderTransportMethod.OwnAxle]: {
    id: RelocationOrderTransportMethod.OwnAxle,
    name: "fit:TransportMethodOwnAxle",
  },
} satisfies Record<RelocationOrderTransportMethod, { id: RelocationOrderTransportMethod; name: string }>;

export class RelocationOrderTransportMethodFilter extends Filter<unknown, unknown> {
  constructor(options?: { id: RelocationOrderTransportMethod; name: string }[], { id }: { id?: string } = {}) {
    super();
    this.options = options ?? Object.values(RELOCATION_ORDER_TRANSPORT_METHOD_FILTER_OPTIONS);
    if (id) this.id = id;
  }

  readonly id: string = "transportMethod";
  readonly labelSingular = "fit:TransportMethod";
  readonly labelPlural = "fit:TransportMethod";
  readonly placeholder = "fit:SelectTransportMethod";
  readonly searchPlaceholder = "fit:SearchTransportMethod";
  readonly emptyText = "fit:NoTransportMethodFound";

  options: { id: RelocationOrderTransportMethod; name: string }[] = [];

  getData(): FilterData {
    return {
      options: this.options,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
